import HomeNav from '../../components/HomeNav/HomeNav.jsx';
import Footer from '../../components/Footer/Footer.jsx';
import shared from './HomePage.module.css';
import useRevealOnScroll from './hooks/useRevealOnScroll.js';
import Hero from './sections/Hero.jsx';
import RevealShowcase from './sections/RevealShowcase.jsx';
import WhyBrand from './sections/WhyBrand.jsx';
import Education from './sections/Education.jsx';
import LevelRoadmap from './sections/LevelRoadmap.jsx';
import Schedule from './sections/Schedule.jsx';
import Cta from './sections/Cta.jsx';
import IntroModal from './sections/IntroModal.jsx';

/**
 * 잉글리시팝(English POP) 메인 랜딩 페이지.
 * 섹션 순서: NAV → HERO → REVEAL SHOWCASE(스크롤 캐릭터 시퀀스→로고) → WHY/BRAND →
 * EDUCATION(cores/growth/routine) → LEVEL ROADMAP(파닉스 과정 인트로 포함) → SCHEDULE →
 * CTA → FOOTER. 각 섹션은 sections/ 아래 개별 컴포넌트로 분리했고, 원본의 6개 JS 모듈은
 * hooks/ 아래 커스텀 훅으로 포팅했다.
 *
 * useRevealOnScroll은 모든 자식 섹션이 마운트된 뒤(useEffect는 자식 → 부모 순서로 실행)
 * 문서 전체의 .reveal 요소를 한 번에 관찰한다 — 원본이 document 전역에서 `.reveal`을
 * 찾던 것과 동일한 동작.
 */
export default function HomePage() {
  useRevealOnScroll(shared.reveal, shared.in);

  return (
    <>
      <HomeNav />
      <Hero />
      <RevealShowcase />
      <WhyBrand />
      <Education />
      <LevelRoadmap />
      <Schedule />
      <Cta />
      <Footer />
      <IntroModal />
    </>
  );
}
